import React, { useEffect, useState } from "react";
import { API } from "../../Redux/actions/API";
import Navbar from "../Navbar/Navbar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateAuth } from "../../Redux/actions/AdminAuthSlice";

function Dashboard() {
  const { userId, jwt_token } = useSelector((state) => state.Auth);
  //console.log("uid", userId);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [dash, setDash] = useState([]);

  const Dashboard_API = async () => {
    try {
      let responceRight = await API?.get(
        `/admindashboarddata?loginid=${userId}`,
        {
          headers: {
            Authorization: jwt_token,
          },
        }
      );
      responceRight = responceRight.data.data[0][0];
      console.log("Dashboard--->", responceRight);
      setDash(responceRight);
    } catch (e) {
      console.log("error Balance APi", e);
      if (
        e.response.data.showableMessage ==
        "Please login to access this resource"
      ) {
        dispatch(updateAuth({ AdminAuth: false, jwt_token: "", userId: null }));
        sessionStorage.clear();
        localStorage.clear();
        navigate("/");
      }
    }
  };

  useEffect(() => {
    Dashboard_API();
  }, []);

  return (
    <div>
      <Navbar />
      {/* {AdminRole.adminrole == "Admin" ? ( */}
      <>
        <div id="wrapper">
          <div class="content-page page_scroll_y">
            <div class="content">
              <div class="container">
                <div class="row">
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Member_Details">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Registration</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUser}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Activation</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayactivation}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Staking</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.totalInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActiveMember">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Staking</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.todayInvest}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryBasic">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Basic Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalactivationBasic}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryBasic">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Basic Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayactivationBasic}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryBronze">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Bronze Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalactivationBronze}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryBronze">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Bronze Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayactivationBronze}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryGold">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Gold Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalactivationGold}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryGold">
                          <div class="gcp-description">
                            <div class="gcp-title">Today's Gold Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayactivationGold}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryPlatinum">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Platinum Staking</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalactivationPlatinum}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="ActivationhistoryPlatinum">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today's Platinum Staking
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayactivationPlatinum}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  {/* <div class="col-md-6">
                    <a href="Level_Income">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Upgrade User</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.TotalUpgradeUser}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <a href="Level_Income">
                      <div class="box features-1">
                        <div class="gen-comp-plan">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Upgrade User</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayUpgradeUser}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div> */}

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1"> {dash.totalWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Withdrawal</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayWithdrawal}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawal}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todayIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Net Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.totalnetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="Withdrawal_History">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Net Income</div>
                            <div class="gcp-income">
                              <span class="cur1">{dash.todaynetIncome}</span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Total Working Income</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalIncome_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">Today Working Income</div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayIncome_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="PendingUsdWithdrawal">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Pending Working Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalPendingWithdrawal_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="PendingUsdWithdrawal">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Pending Working Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayPendingWithdrawal_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="PaidUsdWithdrawal">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Working Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalWithdrawal_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="PaidUsdWithdrawal">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Working Withdrawal
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todayWithdrawal_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Total Net Working Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.totalnetIncome_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="box features-1">
                      <div class="gen-comp-plan">
                        <a href="#">
                          <div class="gcp-description">
                            <div class="gcp-title">
                              Today Net Working Income
                            </div>
                            <div class="gcp-income">
                              <span class="cur1">
                                {dash.todaynetIncome_working}
                              </span>
                            </div>
                          </div>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
      {/* ) : (
        <>
          <div id="wrapper">
            <div class="content-page page_scroll_y">
              <div class="content">
                <div class="container">
                  <div class="row">
                    <h3>Welcome SubAdmin </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )} */}
    </div>
  );
}

export default Dashboard;
